import { getEntity } from 'entman';

import schemas from 'schemas';


export function getPreview(state, id) {
  return getEntity(state, schemas.Preview, id);
}
